import React from 'react'

const Button = ({ component, className }) => {
  const { text, url } = component
  return (
    <a
      className={`bg-rojo-900 text-white text-sm text-center block px-4 sm:px-10 py-2 sm:py-3 rounded-lg hover:bg-red-900 transition-colors ease-in-out duration-300 ${className}`}
      target="_blank"
      rel="noopener noreferrer"
      href={url}>
      {text}
    </a>
  )
}

export default Button
